/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export interface ProgressCurvePoint {
  /** Days since module start */
  moduleDay: number;
  /** Average progress percentage at this day */
  avgProgress: number;
}
